import React, { useEffect } from "react";

import {
  Area,
  AreaChart,
  CartesianGrid,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const data = [
  {
    data: "",
    value: 0,
  },
  {
    data: "YEAR 01",
    value: 6500,
  },
  {
    data: "YEAR 02",
    value: 7500,
  },
  {
    data: "YEAR 03",
    value: 8000,
  },
  {
    data: "YEAR 04",
    value: 10000,
  },
  {
    data: "YEAR 05",
    value: 12000,
  },
];

const ROIChart = ({ gradientColor = "#e11f1c" }) => {
  return (
    <>
      <div className="scroll-x">
        <article className="wallet-chart">
          <div className="section-chart py-5">
            <ResponsiveContainer width="100%" height={400}>
              <AreaChart data={data}>
                <defs>
                  <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                    <stop
                      offset="5%"
                      stopColor={gradientColor}
                      stopOpacity={1}
                    />
                    <stop offset="95%" stopColor="#ffffff" stopOpacity={0.1} />
                  </linearGradient>
                </defs>
                <Area
                  dataKey="value"
                  stroke={gradientColor}
                  strokeWidth={2}
                  fill="url(#colorUv)"
                />
                <XAxis
                  dataKey="data"
                  axisLine={false}
                  tickLine={false}
                  tickCount={12}
                  type="category"
                  tick={{
                    fill: "#404040",
                    fontWeight: "500",
                    fontSize: "0.8rem",
                  }}
                />
                <YAxis
                  dataKey="value"
                  axisLine={false}
                  tickLine={false}
                  tickCount={9}
                  tickFormatter={(number) => `$ ${number}`}
                  tick={{
                    fill: "#404040",
                    fontWeight: "500",
                    fontSize: "0.8rem",
                  }}
                />

                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{
                    stroke: "#e11f1c",
                    radius: 10,
                    strokeDasharray: 5,
                  }}
                />
                <CartesianGrid opacity={0.5} vertical={false} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </article>
      </div>
    </>
  );

  function CustomTooltip({ active, payload, label }) {
    if (active) {
      return <div></div>;
    }
    return null;
  }
};

export default ROIChart;
